<template>
  <div class="w100 cpfa">
    <div class="flexslider">
      <ul class="slides">
        <div
          class="lunBotu"
          :style="{
            background:
              'url(' + require('@/assets/' + Product['background']) + ')'
          }"
        >
          <div class="container">
            <div class="ban2 float">
              <!-- 产品名称 -->
              <div
                class="product"
                :style="{
                  background:
                    'url(' +
                    require('@/assets/' + Product['product']) +
                    ') no-repeat '
                }"
              >
                <span class="reg">&reg;</span>
                <div class="product-h3">
                  <p v-for="(item, index) in Product['h3']" :key="index">
                    {{ item }}
                  </p>
                </div>
                <div class="product-p">
                  <p v-for="(item, index) in Product['p']" :key="index">
                    {{ item }}
                  </p>
                </div>
              </div>
              <!-- 商务合作 -->
              <!-- <img
                class="cpxl"
                :src="require('@/assets/images/chanpin/swhz.png')"
                @click="getCooperate"
              /> -->
              <div class="homelookmore" @click="getCooperate">
                查看详情
              </div>
              <!-- <div class="caiye" @click="gotodownload">
                <p>下载产品介绍</p>
              </div>-->
            </div>
            <!-- 配图 -->
            <img class="banner" :src="require('@/assets/' + Product['img'])" />
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    Product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    getCooperate() {
      //   document.getElementById('submit').scrollIntoView()
      this.$router.push({ name: this.Product["name"] });
    }
    // 跳转到下载文件的位置
    // gotodownload () {
    //   document.getElementById('download').scrollIntoView()
    // }
  }
};
</script>

<style scoped>
.flexslider {
  position: relative;
  height: 600px;
  overflow: hidden;
  z-index: 1;
  clear: both;
  margin-top: -65px;
}
.cpfa .container .float {
  width: 55%;
  margin-top: 18px;
}
.container {
  width: 997px;
}
.cpfa .container .cpxl {
  float: left;
  margin-top: 49px;
  margin-left: 0px;
}
.banner {
  width: 42%;
}
.cpfa .container img {
  max-width: 560px;
  margin-top: 30px;
}
/* 产品 */
.product {
  position: relative;
  width: 30px;
  height: 30px;
}
/* 商标符号 */
.reg {
  position: absolute;
  left: 0px;
  top: 0px;
  margin-left: 116px;
  margin-top: -5px;
  font-size: 25px;
  font-size: 25px;
}
.desc {
  position: absolute;
  left: 0px;
  top: 0px;
  font-size: 56px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  margin-left: 150px;
  margin-top: 9px;
}

.product-h2 {
  font-size: 32px;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
  margin-top: -34px;
  text-align: left;
}
.product-h3 {
  margin-top: -31px;
  font-size: 24px;
  line-height: 65px;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
  text-align: left;
}
.product-h3 p {
  text-align: left;
}
.product-p {
  text-align: left;
  font-size: 16px;
  font-weight: normal;
  color: rgba(153, 152, 152, 1);
  margin-top: 33px;
}
.product-p:last-child {
  margin-top: 20px;
}

.product-p p {
  text-align: left;
}
/* 下再彩页按钮 */
.caiye {
  width: 160px;
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 4px;
  font-size: 20px;
  margin-top: 49px;
  margin-left: 180px;
  line-height: 50px;
  color: rgba(255, 255, 255, 1);
}
.container /deep/ .el-button {
  background: rgba(0, 0, 0, 0.2);
}
.container /deep/ .el-button:hover {
  background: rgba(0, 0, 0, 0);
}
.homelookmore {
  float: left;
  margin-top: 49px;
  margin-left: 0px;
  width: 160px;
  line-height: 50px;
  background: linear-gradient(86deg, #7460ee, #fc487a);
  border-radius: 4px;
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  display: inline-block;
}
.lunBotu {
  margin-top: 4px;
  z-index: 1;
  background-size: 100% 100%;
  height: 593px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/banner.vue